import React from "react";
import InputLabel from "@mui/material/InputLabel";
import {
  DateTimePicker,
  DesktopDateTimePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import { DEFAULT_DATE_FORMAT } from "@/utils/constants";
import DatePickerIcon from "./datePickerIcon";

import "@/utils/dayjs-config";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("UTC");

interface IDateTimeInput extends DesktopDateTimePickerProps {
  label?: string;
  value?: any;
  errorText?: any;
}
function DateTimeInputComponent({ label, errorText, ...rest }: IDateTimeInput) {
  const [open, setOpen] = React.useState(false);

  return (
    <div
      className="date-time-input-root"
      style={{ width: "100%", minWidth: 0 }}
    >
      {label && (
        <InputLabel
          sx={{
            color: "#1F4970",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 5px",
            width: "100%",
            textTransform: "capitalize",
          }}
          {...(typeof label === "string" && { htmlFor: label })}
        >
          {label}
        </InputLabel>
      )}

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          className="date_picker_error"
          timezone="UTC"
          timeSteps={{
            minutes: 1,
          }}
          ampm={false}
          format={DEFAULT_DATE_FORMAT + " HH:mm"}
          {...rest}
          sx={[
            {
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              "& .MuiOutlinedInput-root": {
                fontSize: "0.875rem",
              },
              "& .MuiPickersInputBase-root": {
                width: "100%",
                minWidth: 0,
              },
            },
            errorText
              ? {
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#FF0000",
                  },
                }
              : {
                  "& .MuiOutlinedInput-root": {
                    borderColor: "",
                  },
                },
            errorText
              ? {
                  "& .MuiOutlinedInput-root": {
                    color: "#FA896B",
                  },
                }
              : {
                  "& .MuiOutlinedInput-root": {
                    color: " #1F4970",
                  },
                },
            errorText
              ? {
                  "& .MuiOutlinedInput-root": {
                    border: "1px solid #F00",
                  },
                }
              : {
                  "& .MuiOutlinedInput-root": {
                    border: "",
                  },
                },
          ]}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          slots={{
            openPickerIcon: (props) => (
              <DatePickerIcon
                {...props}
                color={rest?.disabled ? "#BDBDBD" : "#1F4970"}
              />
            ),
          }}
          slotProps={{
            textField: {
              error: errorText,
              helperText: errorText,
              style: {
                color: errorText ? "#F00" : "#000",
              },
              onClick: () => setOpen(true),
              id: label || "date-picker",
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
}

export default DateTimeInputComponent;
